module.exports = __webpack_public_path__ + "img/AX.32761e56.svg";